import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";

const About = () => {
  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState("");

  useEffect(() => {
    setPrevLocation(location.state?.data || "");
  }, [location]);

  return (
    <div className="max-w-container mx-auto px-4 space-y-12">

      {/* Breadcrumbs */}
      <Breadcrumbs title="About" prevLocation={prevLocation} />

      {/* Factory Introduction Section */}
      <div className="w-full flex flex-col md:flex-row items-center gap-8 md:gap-12">
        <div className="md:w-1/2 space-y-4">
          <h2 className="text-3xl md:text-4xl font-bold text-primeColor">
            Our Journey
          </h2>
          <p className="text-base md:text-lg text-lightText">
            We started with a <span className="font-semibold">chocolate factory</span> and specialized in 
            <span className="font-semibold"> Arabic sweets</span>, bringing the finest quality and authentic taste to our customers. 
            Over the years, we expanded to become <span className="font-semibold">BigMart Hypermarket</span>, offering a wide variety of products in Ajman, UAE.
          </p>
        </div>
      </div>

      {/* Banner Section (Text Only) */}
      <div className="w-full bg-black text-white rounded-lg p-6 md:p-12">
        <h1 className="text-2xl md:text-4xl font-bold mb-2">
          Welcome to BigMart Hypermarket
        </h1>
        <p className="text-sm md:text-base max-w-lg">
          Your one-stop destination for groceries, electronics, fashion, fresh produce, and much more.
          We bring you quality products at unbeatable prices, with an exceptional shopping experience.
        </p>
      </div>

      {/* About Text Section */}
      <div className="space-y-6">
        <h2 className="text-2xl font-semibold text-primeColor">About Us</h2>
        <p className="text-base text-lightText max-w-3xl">
          <span className="text-primeColor font-semibold">BigMart Hypermarket</span> 
          has been serving the community in Ajman, UAE, with a wide range of products spanning groceries, household items, electronics, and fashion. Our mission is to provide high-quality goods at affordable prices, with a focus on customer satisfaction and a delightful shopping experience.
        </p>
        <p className="text-base text-lightText max-w-3xl">
          We believe in combining modern retail practices with traditional values, ensuring that every customer leaves our store happy and satisfied. Our friendly staff and organized store layout make shopping convenient and enjoyable for everyone.
        </p>

        {/* Enquiry Button */}
        <a
          href="https://wa.me/0542660433"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block w-52 h-12 bg-primeColor text-white hover:bg-black duration-300 rounded-md mt-4 flex items-center justify-center text-lg font-semibold"
        >
          Make an Enquiry
        </a>
      </div>
    </div>
  );
};

export default About;